// Per-deployment branding, set via VITE_APP_NAME in each store's .env file.
// Falls back to a generic name so a fresh deployment never shows another
// store's brand.
export const APP_NAME = import.meta.env.VITE_APP_NAME || 'POS';

export function pageTitle(section?: string): string {
  return section ? `${section} - ${APP_NAME}` : APP_NAME;
}
